import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PLACE_PREDICTIONS } from '../../queries/get-place-predictions.js';
import '../../queries/get-place-details.js';
import fromQueryPlacePredictionsToPlacePredictions from './adapters/fromQueryPlacePredictionsToPlacePredictions.js';

const usePlacePredictions = (options)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_PREDICTIONS, swcHelpers.objectSpread({}, options));
    const data = React.useMemo(()=>{
        var ref;
        return fromQueryPlacePredictionsToPlacePredictions((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placePredictions);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { usePlacePredictions as default };
//# sourceMappingURL=use-place-predictions.js.map
